import axios from 'axios';

import { ICompanyActivityStatus } from '@/shared/model/company-activity-status.model';

const baseApiUrl = 'api/company-activity-statuses';

export default class CompanyActivityStatusService {
  public find(id: number): Promise<ICompanyActivityStatus> {
    return new Promise<ICompanyActivityStatus>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ICompanyActivityStatus): Promise<ICompanyActivityStatus> {
    return new Promise<ICompanyActivityStatus>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ICompanyActivityStatus): Promise<ICompanyActivityStatus> {
    return new Promise<ICompanyActivityStatus>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
